import { jsx as p } from "react/jsx-runtime";
import { T as u } from "../../chunks/title-banner.cY4BxAfL.js";
import { useSitecoreContext as l } from "@sitecore-jss/sitecore-jss-nextjs";
const d = ({
  rendering: e,
  fallbackTitle: m = { value: "Page Title" }
}) => {
  var i, r, a, s;
  const { sitecoreContext: t } = l(), o = (t == null ? void 0 : t.route) !== void 0;
  return /* @__PURE__ */ p(
    u,
    {
      title: o ? (r = (i = t.route) == null ? void 0 : i.fields) == null ? void 0 : r.pageTitle : m,
      description: o ? (s = (a = t.route) == null ? void 0 : a.fields) == null ? void 0 : s.pageShortDescription : void 0,
      dataTestId: e == null ? void 0 : e.componentName,
      withBreadcrumbs: !0
    }
  );
};
export {
  d as PageTitleBannerLarge
};
